"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressToJSON = exports.AddressFromJSONTyped = exports.AddressFromJSON = exports.instanceOfAddress = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the Address interface.
 */
function instanceOfAddress(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAddress = instanceOfAddress;
function AddressFromJSON(json) {
    return AddressFromJSONTyped(json, false);
}
exports.AddressFromJSON = AddressFromJSON;
function AddressFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'street': !(0, runtime_1.exists)(json, 'street') ? undefined : json['street'],
        'zipCode': !(0, runtime_1.exists)(json, 'zipCode') ? undefined : json['zipCode'],
        'city': !(0, runtime_1.exists)(json, 'city') ? undefined : json['city'],
        'country': !(0, runtime_1.exists)(json, 'country') ? undefined : json['country'],
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'stateProvinceCode': !(0, runtime_1.exists)(json, 'stateProvinceCode') ? undefined : json['stateProvinceCode'],
    };
}
exports.AddressFromJSONTyped = AddressFromJSONTyped;
function AddressToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'street': value.street,
        'zipCode': value.zipCode,
        'city': value.city,
        'country': value.country,
        'email': value.email,
        'id': value.id,
        'stateProvinceCode': value.stateProvinceCode,
    };
}
exports.AddressToJSON = AddressToJSON;
